import axios from 'axios';
import { message } from 'antd';
import { history } from '../../../History';
import config from '../../../config/api';
import { resetAuthReducer } from '../Auth/AuthActions';
import { togglePreloader } from '../App/AppActions';
import { setTemplateReportList } from '../Misc/MiscActions';

export const setUserList = (data) => ({
  type: 'SET_USER_LIST',
  data
})

export const setUserReportList = (data) => ({
  type: 'SET_USER_REPORT_LIST',
  data
})

export const setConversationUser = (data) => ({
  type: 'SET_CONVERSATION_USER',
  data
})

export const setConversationReport = (data) => ({
  type: 'SET_CONVERSATION_REPORT',
  data
})

export const setConversationData = (data) => ({
  type: 'SET_CONVERSATION_DATA',
  data
})

export const setConversationLoading = (data) => ({
  type: 'LOADING_CONVERSATION_DATA',
  data
})

export const toggleConversationPopup = (data) => ({
  type: 'TOGGLE_CONVERSATION_POPUP',
  data
})

export const toggleAttachPopup = (data) => ({
  type: 'TOGGLE_ATTACH_POPUP',
  data
})

export const setAttachPopupLoading = (data) => ({
  type: 'SET_ATTACH_POPUP_LOADING',
  data
})

export const setReportFilesList = (data) => ({
  type: 'SET_REPORT_FILES_LIST',
  data
})

export const setIsReportAttaching = (data) => ({
  type: 'SET_IS_REPORT_ATTACHING',
  data
})

export const setReportSearchResult = (data) => ({
  type: 'SET_REPORT_SEARCH_RESULT',
  data
})

export const setReportsToAttach = (data) => ({
  type: 'SET_REPORTS_TO_ATTACH',
  data
})

export const setTemplateList = (data) => ({
  type: 'SET_TEMPLATE_LIST',
  data
})

export const setTemplateId = (data) => ({
  type: 'SET_TEMPALTE_ID',
  data
})

export const setTemplateReports = (data) => ({
  type: 'SET_TEMPLATE_REPORTS',
  data
})

export const setSelectedTemplateReports = (data) => ({
  type: 'SET_SELECTED_TEMPLATE_REPORTS',
  data
})

export const setScratchReports = (data) => ({
  type: 'SET_SCRATCH_REPORTS',
  data
})

export const setIsReportAssigning = (data) => ({
  type: 'SET_IS_REPORT_ASSIGNING',
  data
})

export const getUserList = (from) => {
  return function (dispatch) {
    dispatch(togglePreloader(true));
    const token = JSON.parse(sessionStorage.getItem('user')).data.token;
    const email = JSON.parse(sessionStorage.getItem('user')).data.email;
    const role = JSON.parse(sessionStorage.getItem('user')).data.role;
    const form_data = {
      cmd: 'boxuser:list',
      type: from,
      auth: { key: token },
      authUser: {
        role, email
      }
    };
    axios({
      method: 'post',
      url: `${config.api_url}`,
      data: form_data
    })
      .then(response => {
        if (response.data.reply.code === 200) {
          dispatch(setUserList(response.data.reply.message));
          dispatch(togglePreloader(false));
        }
        if (response.data.reply.code === 204) {
          message.warning(response.data.reply.message);
          dispatch(togglePreloader(false));
        }
        else if (response.data.reply.code === 401 || response.data.reply.code === 403) {
          message.error('You have been logged out! Please login to continue');
          dispatch(togglePreloader(false));
          dispatch(resetAuthReducer());
          history.push('/');
        }
      })
      .catch((error) => {
        dispatch(togglePreloader(false));
      })
  }
}

export const getUserReportList = (id, from) => {
  return function (dispatch) {
    dispatch(togglePreloader(true));
    const token = JSON.parse(sessionStorage.getItem('user')).data.token;
    const email = JSON.parse(sessionStorage.getItem('user')).data.email;
    const role = JSON.parse(sessionStorage.getItem('user')).data.role;
    const form_data = {
      cmd: 'boxuser:reportList',
      auth: { key: token },
      user_id: id,
      type: from,
      authUser: {
        role, email
      }
    };
    axios({
      method: 'post',
      url: `${config.api_url}`,
      data: form_data
    })
      .then(response => {
        if (response.data.reply.code === 200) {
          console.log(response);
          dispatch(setUserReportList(response.data.reply.message));
          dispatch(togglePreloader(false));
        }
        else if (response.data.reply.code === 204) {
          message.warning(response.data.reply.message);
          dispatch(togglePreloader(false));
        }
        else if (response.data.reply.code === 401 || response.data.reply.code === 403) {
          message.error('You have been logged out! Please login to continue');
          dispatch(togglePreloader(false));
          dispatch(resetAuthReducer());
          history.push('/');
        }
      })
      .catch((error) => {
        dispatch(togglePreloader(false));
      })
  }
}

export const fetchConversationData = (user_id, report_id, from) => {
  return function (dispatch) {
    dispatch(setConversationLoading(true));
    const token = JSON.parse(sessionStorage.getItem('user')).data.token;
    const email = JSON.parse(sessionStorage.getItem('user')).data.email;
    const role = JSON.parse(sessionStorage.getItem('user')).data.role;
    const form_data = {
      cmd: 'chatandcustomization:fetch',
      auth: { key: token },
      user_id: user_id,
      report_id: report_id,
      type: from,
      authUser: {
        role, email
      }
    };
    axios({
      method: 'post',
      url: `${config.api_url}`,
      data: form_data
    })
      .then(response => {
        if (response.data.reply.code === 200) {
          if (response.data.reply.message.hasOwnProperty('chats')) {
            dispatch(setConversationData(response.data.reply.message.chats));
          }
          else {
            dispatch(setConversationData(response.data.reply.message.customization_reqs));
          }
          dispatch(setConversationLoading(false));
        }
        else if (response.data.reply.code === 401 || response.data.reply.code === 403) {
          message.error('You have been logged out! Please login to continue');
          dispatch(setConversationLoading(false));
          dispatch(resetAuthReducer());
          history.push('/');
        }
      })
      .catch((error) => {
        dispatch(setConversationLoading(false));
      })
  }
}

export const replyToConversation = (user_id, report_id, message, e) => {
  return function (dispatch) {
    dispatch(setConversationLoading(true));
    const token = JSON.parse(sessionStorage.getItem('user')).data.token;
    const email = JSON.parse(sessionStorage.getItem('user')).data.email;
    const role = JSON.parse(sessionStorage.getItem('user')).data.role;
    const form_data = {
      cmd: 'chat:reply',
      auth: { key: token },
      user_id: user_id,
      report_id: report_id,
      message: message,
      authUser: {
        role, email
      }
    };
    axios({
      method: 'post',
      url: `${config.api_url}`,
      data: form_data
    })
      .then(response => {
        if (response.data.reply.code === 200) {
          if (response.data.reply.message.hasOwnProperty('chats')) {
            dispatch(setConversationData(response.data.reply.message.chats));
          }
          else {
            dispatch(setConversationData(response.data.reply.message.customization_reqs));
          }
          dispatch(setConversationLoading(false));
          message.success('Message Sent!');
          e.target.reset();
        }
        else if (response.data.reply.code === 401 || response.data.reply.code === 403) {
          message.error('You have been logged out! Please login to continue');
          dispatch(setConversationLoading(false));
          dispatch(resetAuthReducer());
          e.target.reset();
          history.push('/');
        }
      })
      .catch((error) => {
        dispatch(setConversationLoading(false));
        e.target.reset();
      })
  }
}

export const fetchReportFiles = (user_id, report_id) => {
  return function (dispatch) {
    dispatch(setAttachPopupLoading(true));
    const token = JSON.parse(sessionStorage.getItem('user')).data.token;
    const email = JSON.parse(sessionStorage.getItem('user')).data.email;
    const role = JSON.parse(sessionStorage.getItem('user')).data.role;
    const form_data = {
      cmd: 'reports:list',
      auth: { key: token },
      user_id: user_id,
      report_id: report_id,
      authUser: {
        role, email
      }
    };
    axios({
      method: 'post',
      url: `${config.api_url}`,
      data: form_data
    })
      .then(response => {
        if (response.data.reply.code === 200) {
          console.log(response);
          dispatch(setAttachPopupLoading(false));
          dispatch(setReportFilesList(response.data.reply.message));
          const reports_to_attach = response.data.reply.message.user_reports.sheets.length > 0 ? response.data.reply.message.user_reports.sheets.map(report => report.type + `:` + report.id) : [];
          dispatch(setReportsToAttach(reports_to_attach));
        }
        else if (response.data.reply.code === 401 || response.data.reply.code === 403) {
          message.error('You have been logged out! Please login to continue');
          dispatch(setAttachPopupLoading(false));
          dispatch(resetAuthReducer());
          history.push('/');
        }
      })
      .catch((error) => {
        dispatch(setAttachPopupLoading(false));
      })
  }
}

export const uploadFile = (values) => {
  return function (dispatch) {
    const token = JSON.parse(sessionStorage.getItem('user')).data.token;
    const email = JSON.parse(sessionStorage.getItem('user')).data.email;
    const role = JSON.parse(sessionStorage.getItem('user')).data.role;
    const form_data = {
      cmd: 'fileupload:authenticate',
      auth: { key: token },
      fileName: values.dragger.file.name,
      type: values.type,
      report_id: parseInt(values.report_id),
      authUser: {
        role, email
      }
    };
    axios({
      method: 'post',
      url: `${config.api_url}`,
      data: form_data
    })
      .then(response => {
        message.info('Uploading File!');
        if (response.data.reply.code === 200) {
          let formData = new FormData();
          let param_keys = Object.keys(response.data.reply.message.params);
          for (let i = 0; i < param_keys.length; i++) {
            formData.append(param_keys[i], response.data.reply.message.params[param_keys[i]]);
          }
          delete values.dragger.file.error
          delete values.dragger.file.status
          formData.append('file', values.dragger.file.originFileObj);
          axios({
            method: 'post',
            url: response.data.reply.message.upload_url,
            data: formData,

            headers: { "Content-Type": "multipart/form-data;boundary=------WebKitFormBoundaryE19zNvXGzXaLvS5C" }
          })
            .then(response => {
              message.success('File Uploaded Successfully!');
            })
            .catch(error => {
              message.error('Something went wrong! Please try again!');
            })
        }
        else if (response.data.reply.code === 400) {
          message.error('Something went wrong! Please try again!');
        }
        else if (response.data.reply.code === 401 || response.data.reply.code === 403) {
          message.error('You have been logged out! Please login to continue');
          dispatch(resetAuthReducer());
          history.push('/');
        }
      })
      .catch((error) => {
        message.error('Something went wrong! Please try again!');
      })
  }
}

export const searchReportTitles = (query, from) => {
  return function (dispatch) {
    axios({
      method: 'get',
      url: `https://www.mordorintelligence.com/api/reports/search?q=${query}`,
    })
      .then(response => {
        if (from === 'box' || from === 'assign-reports') {
          if (Array.isArray(response.data)) {
            dispatch(setReportSearchResult(response.data));
          }
          else {
            dispatch(setReportSearchResult([]));
          }
        }
        else {
          if (Array.isArray(response.data)) {
            dispatch(setTemplateReportList(response.data));
          }
          else {
            dispatch(setTemplateReportList([]));
          }
        }
      })
      .catch((error) => {
        console.log(error);
      })
  }
}

export const attachReportFilesToUser = (user_id, report_id, report_list) => {
  return function (dispatch) {
    dispatch(setIsReportAttaching(true));
    const token = JSON.parse(sessionStorage.getItem('user')).data.token;
    const email = JSON.parse(sessionStorage.getItem('user')).data.email;
    const role = JSON.parse(sessionStorage.getItem('user')).data.role;
    report_list = report_list.map(report => {
      return {
        type: report.split(":")[0],
        id: parseInt(report.split(":")[1])
      }
    });
    const form_data = {
      cmd: 'sheet:attach',
      auth: { key: token },
      user_id: user_id,
      report_id: report_id,
      reportsList: report_list,
      authUser: {
        role, email
      }
    };
    axios({
      method: 'post',
      url: `${config.api_url}`,
      data: form_data
    })
      .then(response => {
        if (response.data.reply.code === 200) {
          message.success(response.data.reply.message);
          dispatch(setIsReportAttaching(false));
          dispatch(toggleAttachPopup(false));
        }
        else if (response.data.reply.code === 400) {
          message.error(response.data.reply.message);
          dispatch(setIsReportAttaching(false));
        }
        else if (response.data.reply.code === 401 || response.data.reply.code === 403) {
          message.error('You have been logged out! Please login to continue');
          dispatch(setIsReportAttaching(false));
          dispatch(toggleAttachPopup(false));
          dispatch(resetAuthReducer());
          history.push('/');
        }
      })
      .catch((error) => {
        dispatch(setIsReportAttaching(false));
        dispatch(toggleAttachPopup(false));
      })
  }
}

export const getTemplateList = (from) => {
  return function (dispatch) {
    dispatch(togglePreloader(true));
    const token = JSON.parse(sessionStorage.getItem('user')).data.token;
    const email = JSON.parse(sessionStorage.getItem('user')).data.email;
    const role = JSON.parse(sessionStorage.getItem('user')).data.role;
    const form_data = {
      cmd: 'reportTemplate:list',
      auth: { key: token },
      authUser: {
        role, email
      }
    };
    axios({
      method: 'post',
      url: `${config.api_url}`,
      data: form_data
    })
      .then(response => {
        if (response.data.reply.code === 200) {
          dispatch(setTemplateList(response.data.reply.message));
          dispatch(togglePreloader(false));
        }
        else if (response.data.reply.code === 401 || response.data.reply.code === 403) {
          console.log(response.data.reply.message);
          dispatch(resetAuthReducer());
          dispatch(togglePreloader(false));
          history.push('/');
        }
      })
      .catch((error) => {
        dispatch(togglePreloader(false));
        console.log(error);
      })
  }
}

export const getTemplateReports = (id) => {
  return function (dispatch) {
    const token = JSON.parse(sessionStorage.getItem('user')).data.token;
    const email = JSON.parse(sessionStorage.getItem('user')).data.email;
    const role = JSON.parse(sessionStorage.getItem('user')).data.role;
    const form_data = {
      cmd: 'templateReport:list',
      auth: { key: token },
      id: id,
      authUser: {
        role, email
      }
    };
    axios({
      method: 'post',
      url: `${config.api_url}`,
      data: form_data
    })
      .then(response => {
        if (response.data.reply.code === 200) {
          dispatch(setTemplateReports(response.data.reply.message));
          dispatch(setSelectedTemplateReports(response.data.reply.message.map(report => report.id)));
        }
        else if (response.data.reply.code === 401 || response.data.reply.code === 403) {
          message.error('You have been logged out! Please login to continue');
          dispatch(resetAuthReducer());
          history.push('/');
        }
      })
      .catch((error) => {
        console.log(error);
      })
  }
}

export const assignReports = (user_id, report_id) => {
  return function (dispatch) {
    dispatch(setIsReportAssigning(true));
    const token = JSON.parse(sessionStorage.getItem('user')).data.token;
    const email = JSON.parse(sessionStorage.getItem('user')).data.email;
    const role = JSON.parse(sessionStorage.getItem('user')).data.role;
    const form_data = {
      cmd: 'report:assign',
      auth: { key: token },
      user_id: user_id,
      report_id: report_id,
      authUser: {
        role, email
      }
    };
    axios({
      method: 'post',
      url: `${config.api_url}`,
      data: form_data
    })
      .then(response => {
        if (response.data.reply.code === 200) {
          message.success(response.data.reply.message);
          dispatch(setIsReportAssigning(false));
          dispatch(setReportSearchResult([]));
          dispatch(setTemplateReports([]));
          dispatch(setSelectedTemplateReports([]));
          dispatch(setScratchReports([]));
        }
        else if (response.data.reply.code === 204) {
          message.error(response.data.reply.message);
          dispatch(setIsReportAssigning(false));
          dispatch(setReportSearchResult([]));
          dispatch(setTemplateReports([]));
          dispatch(setSelectedTemplateReports([]));
          dispatch(setScratchReports([]));
        }
        else if (response.data.reply.code === 401 || response.data.reply.code === 403) {
          message.error('You have been logged out! Please login to continue');
          dispatch(setIsReportAssigning(false));
          dispatch(setReportSearchResult([]));
          dispatch(setTemplateReports([]));
          dispatch(setSelectedTemplateReports([]));
          dispatch(setScratchReports([]));
          dispatch(resetAuthReducer());
          history.push('/');
        }
      })
      .catch((error) => {
        dispatch(setIsReportAssigning(false));
        dispatch(setReportSearchResult([]));
        dispatch(setTemplateReports([]));
        dispatch(setSelectedTemplateReports([]));
        dispatch(setScratchReports([]));
      })
  }
}


// WEBPACK FOOTER //
// ./src/redux/actions/Box/BoxActions.js